

















import {Component, Vue} from "vue-property-decorator";
import {subscribeInterface} from "@/services/api";
import {SubscribeResp} from "@/model/Subscribe";

@Component({})
export default class Subscribe extends Vue {
  public companyInfo: SubscribeResp = {};
  public content = '';
  public defaultImg = false;
  public subscribeText = ''
  created() {
      document.title = 'Subscribe';
      document.querySelector('meta[property="og:title"]')?.setAttribute('content', 'Subscribe');
      this.content = String(this.$route.query.content || '');
    subscribeInterface({content: this.content}).then(res => {
      this.companyInfo = res?.data?.data;
      !this.companyInfo.logo && (this.defaultImg = true);
      if (res?.data?.data?.companyId == '173' && location?.pathname === '/resubscribe') {
          this.subscribeText = 'メール配信の再開しました'
          
      }else{
          this.subscribeText =   location.pathname === '/resubscribe'?
          `You've successfully been resubscribed.` :
          `You've successfully been subscribed.`;
      }
    }).catch(res => {
      this.defaultImg = true;
    })
  }
}
